import { render } from "./Widget9.vue?vue&type=template&id=10f0d3b5&ts=true"
import script from "./Widget9.vue?vue&type=script&lang=ts"
export * from "./Widget9.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__